import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { baseUrl } from './api-config';

export class SegnalibroConProva {
    key: string; //nome del segnalibro
    value: any; //risultato della chiamata del segnalibro su un incarico
    error?: any; //eventuale errore
}


@Injectable({
    providedIn: 'root'
})

export class SegnalibroService {
    constructor(private httpClient: HttpClient) {

    }

    provaSegnalibriSu(incarico): Observable<SegnalibroConProva[]> {
        return this.httpClient.get<SegnalibroConProva[]>(`${baseUrl}/segnalibri/prova`, {
            params: {
                incarico: "" + incarico,
            }
        });
    }

    loadDatiPerizia(incarico): Promise<any> {
        return this.httpClient.get<any>(`${baseUrl}/segnalibri/dati-perizia`, {
            params: {
                incaricoId: "" + incarico.id,
            }
        }).toPromise();
    }
}
